/**
 * Performs an asynchronous "sleep" for the specified amount of time.
 * 
 * Example: await sleep(500);
 * @param time The time to sleep in ms.
 */
export function sleep(time: number) {
    return new Promise<void>(resolve => setTimeout(resolve, time));
}